"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const utils_1 = require("../../utils");
const AccountLoading_1 = require("./AccountLoading");
const LoggedInDropdown_1 = require("./LoggedInDropdown");
const SignInDropdown_1 = require("./SignInDropdown");
const SignInLink_1 = require("./SignInLink");
const Styled = styled_components_1.default.div `
	a {
		padding: 16px 12px;
	}

	i {
		margin: 0 4px;
	}

	span.user-label {
		top: -3px;
		position: relative;
		white-space: nowrap;
	}
`;
const Account = (props) => {
    const { displayName, isLoggedIn, accountLinks = {}, rightAlign, accountLoading } = props;
    const { signInLinks = [], signOutLink, dropdownLinks = [] } = accountLinks;
    const signInDropdown = (signInLinks === null || signInLinks === void 0 ? void 0 : signInLinks.length) && signInLinks.length > 1;
    const firstSignInLink = signInLinks[0] || (0, utils_1.defaultSignInLink)();
    let signInEl = (react_1.default.createElement(LoggedInDropdown_1.LoggedInDropdown, { dropdownLinks: dropdownLinks, signOutLink: signOutLink, displayName: displayName, rightAlign: rightAlign }));
    if (accountLoading) {
        signInEl = react_1.default.createElement(AccountLoading_1.AccountLoading, null);
    }
    else if (!isLoggedIn) {
        if (signInDropdown) {
            signInEl = react_1.default.createElement(SignInDropdown_1.SignInDropdown, { signInLinks: signInLinks, rightAlign: rightAlign });
        }
        else {
            signInEl = react_1.default.createElement(SignInLink_1.SignInLink, { href: firstSignInLink.href });
        }
    }
    return react_1.default.createElement(Styled, null, signInEl);
};
exports.Account = Account;
//# sourceMappingURL=Account.js.map